import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import HeadingM from "../../components/shared/HeadingM"
import Layout from "../../components/nico/Layout"
import SEO from "../../components/Seo"
import About from "../../components/shared/usage/About"
import Fee from "../../components/shared/usage/Fee"
import Procedure from "../../components/shared/usage/Procedure"
import { PAGE } from "../../constants"

const usage = () => {
  return (
    <Layout>
      <SEO title={PAGE.title.usage} siteTitle="nico" />
      <HeadingL title={PAGE.title.usage} target="nico" />
      <HeadingM title="ご利用について" target="nico" />
      <About />
      <HeadingM title="ご利用料金" target="nico" />
      <Fee target="nico" />
      <HeadingM title="ご利用手順" target="nico" />
      <Procedure target="nico" />
    </Layout>
  )
}

export default usage
